import InstallOrderDetailModal from './install-order-detail-modal.vue'
export default InstallOrderDetailModal
